export enum Environment {
  DEMO = 0,
  PROD = 1,
}
